import { isEntityLoaded } from '@/Models/Entity';
import { CssBaseline } from '@mui/material';
import { useEffect, useState } from 'react';
import { Outlet, Route } from 'react-router';
import * as API from '../API';
import LoadingFullPage from '../Components/LoadingFullPage/LoadingFullPage';
import AppContextProvider from '../Contexts/App';
import { useAuthenticationContext } from '../Contexts/App/AuthenticationContext';
import ErrorPage from '../Pages/ErrorPage/ErrorPage';
import AuthenticatedRoutes from './Authenticated';
import LoginRouteRoot from './LoginRouteRoot';
import { DobTooltipBlocks } from '@dedalusdiit/dob-components';

const AppRoot = (): React.ReactElement => {
    return (
        <AppContextProvider>
            <CssBaseline />
            <DobTooltipBlocks.Provider>
                <AppRootContent />
            </DobTooltipBlocks.Provider>
        </AppContextProvider>
    );
};

const AppRootContent = (): React.ReactElement => {
    const authenticationContext = useAuthenticationContext();
    const appContextDataIsLoading = !isEntityLoaded(authenticationContext.user);
    const [appConfigIsLoading, setAppConfigIsLoading] = useState(true);

    // Should propably be moved at some point, just keeping it simple for now
    useEffect(() => {
        void API.general.getAppConfig().then(() => {
            document.title = `RISonWEB ${window.appConfig.ServerProvidedConfig.Version}`;
            setAppConfigIsLoading(false);
        });
    }, []);

    if (appContextDataIsLoading || appConfigIsLoading) {
        return (<LoadingFullPage />);
    }

    return (<Outlet />);
};

const Routes = (): React.ReactNode => {
    return (
        <Route path="/" element={<AppRoot />} errorElement={<ErrorPage />}>
            <Route path="/login/*" caseSensitive={false} element={<LoginRouteRoot />} />
            {AuthenticatedRoutes()}
        </Route>
    );
};

export default Routes;
